<template>
  <button
    :type="type"
    :disabled="disabled"
    :class="buttonClasses"
    v-bind="passthroughAttrs"
    @click="handleClick"
  >
    <slot />
  </button>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HdButton',

  inheritAttrs: false,

  props: {
    variant: {
      type: String,
      default: 'secondary'
    },
    type: {
      type: String,
      default: 'button'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    }
  },

  emits: ['click'],

  computed: {
    buttonClasses() {
      const classes = ['btn', `btn-${this.variant}`, this.$attrs.class].flat().filter(Boolean);

      if (this.block) classes.push('btn-block');

      return classes;
    },

    passthroughAttrs() {
      const { class: _class, ...attrs } = this.$attrs;

      return attrs;
    }
  },

  methods: {
    handleClick(event) {
      this.$emit('click', event);
    }
  }
});
</script>
